(function () {
  'use strict';

  const STORAGE_KEY = 'sevyn_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {

      const handle = button.getAttribute('data-product-handle');

      const saved = wishlist.some(function (item) {
        return item.handle === handle;
      });

      button.classList.toggle('is-active', saved);

    });
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (element) {

      element.textContent = count;

      if (count > 0) {
        element.style.display = 'flex';
      } else {
        element.style.display = 'none';
      }

    });
  }

  function updateWishlistPage() {

    const grid = document.querySelector('[data-sevyn-wishlist-grid]');
    const empty = document.querySelector('[data-sevyn-wishlist-empty]');

    if (!grid) {
      return;
    }

    const wishlist = getWishlist();

    if (wishlist.length === 0) {

      grid.innerHTML = '';

      if (empty) {
        empty.style.display = 'flex';
      }

      return;
    }

    if (empty) {
      empty.style.display = 'none';
    }

    grid.innerHTML = wishlist.map(function (item) {

      return `
        <div class="SevynWishlistItem">

          <a
            href="${item.url}"
            class="SevynWishlistItem__Image"
          >
            <img
              src="${item.image}"
              alt="${item.title}"
              loading="lazy"
            >
          </a>

          <div class="SevynWishlistItem__Content">

            <a
              href="${item.url}"
              class="SevynWishlistItem__Title"
            >
              ${item.title}
            </a>

            <div class="SevynWishlistItem__Price">
              ${item.price}
            </div>

            <div class="SevynWishlistItem__Actions">

              <button
                type="button"
                class="SevynWishlistItem__Add"
                data-wishlist-add-cart
                data-variant-id="${item.variantId}"
              >
                ADD TO CART
              </button>

              <button
                type="button"
                class="SevynWishlistItem__Remove"
                data-wishlist-remove="${item.handle}"
              >
                REMOVE
              </button>

            </div>

          </div>

        </div>
      `;

    }).join('');

  }

  document.addEventListener('click', function (event) {

    /* =========================
       WISHLIST BUTTON
       ========================= */

    const wishlistButton =
      event.target.closest('[data-wishlist-button]');

    if (wishlistButton) {

      event.preventDefault();
      event.stopPropagation();

      const handle =
        wishlistButton.getAttribute('data-product-handle');

      const wishlist = getWishlist();

      const existingIndex =
        wishlist.findIndex(function (item) {
          return item.handle === handle;
        });

      if (existingIndex !== -1) {

        wishlist.splice(existingIndex, 1);

      } else {

        wishlist.push({

          id: wishlistButton.getAttribute('data-product-id'),

          variantId:
            wishlistButton.getAttribute('data-variant-id'),

          handle: handle,

          title:
            wishlistButton.getAttribute('data-product-title'),

          url:
            wishlistButton.getAttribute('data-product-url'),

          image:
            wishlistButton.getAttribute('data-product-image'),

          price:
            wishlistButton.getAttribute('data-product-price')

        });

      }

      saveWishlist(wishlist);

      updateWishlistButtons();
      updateWishlistCount();
      updateWishlistPage();

      return;
    }


    /* =========================
       REMOVE
       ========================= */

    const removeButton =
      event.target.closest('[data-wishlist-remove]');

    if (removeButton) {

      event.preventDefault();

      const handle =
        removeButton.getAttribute('data-wishlist-remove');

      const wishlist =
        getWishlist().filter(function (item) {
          return item.handle !== handle;
        });

      saveWishlist(wishlist);

      updateWishlistButtons();
      updateWishlistCount();
      updateWishlistPage();

      return;
    }


    /* =========================
       ADD TO CART
       ========================= */

    const addButton =
      event.target.closest('[data-wishlist-add-cart]');

    if (addButton) {

      event.preventDefault();

      const variantId =
        addButton.getAttribute('data-variant-id');

      if (!variantId) {
        return;
      }

      addButton.disabled = true;

      fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })

      })
      .then(function (response) {

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        return response.json();

      })
      .then(function () {

        addButton.disabled = false;

        window.location.href = '/cart';

      })
      .catch(function () {

        addButton.disabled = false;

      });

    }

  });


  function initWishlist() {

    updateWishlistButtons();
    updateWishlistCount();
    updateWishlistPage();

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initWishlist
    );

  } else {

    initWishlist();

  }

})();